import { Coordinates, Size } from '../../game/model/types';

export interface IDrawable {
  position: Coordinates;
  size: Size;
  visibility: boolean;
  opacity: number;
  render(context: CanvasRenderingContext2D): void;
}

export default class Drawable implements IDrawable {
  opacity = 1;
  rotation = 0;
  width = 0;
  height = 0;
  visibility = true;
  image: CanvasImageSource = new Image();
  position = { x: 0, y: 0 };
  context: CanvasRenderingContext2D;

  constructor(context: CanvasRenderingContext2D) {
    this.context = context;
  }

  set size(size: { width: number; height: number }) {
    this.width = size.width;
    this.height = size.height;
  }

  get size() {
    return { width: this.width, height: this.height };
  }

  private canDraw() {
    return this.visibility && this.context && this.image;
  }

  render(context: CanvasRenderingContext2D) {
    if (!this.canDraw()) return;
    context.globalAlpha = this.opacity;
    if (this.rotation === 0) {
      context.drawImage(
        this.image,
        Math.round(this.position.x - this.size.width / 2),
        Math.round(this.position.y - this.size.height / 2),
        Math.round(this.size.width),
        Math.round(this.size.height)
      );
    } else {
      const rad = this.rotation * (Math.PI / 180);
      context.save();
      context.translate(this.position.x, this.position.y);
      context.rotate(rad);
      context.drawImage(
        this.image,
        -this.size.width / 2,
        -this.size.height / 2,
        Math.round(this.size.width),
        Math.round(this.size.height)
      );
      context.restore();
    }
    context.globalAlpha = 1;
  }
}
